import { render } from "./RestaurantSettingsView.vue?vue&type=template&id=267ecc8d&scoped=true"
import script from "./RestaurantSettingsView.vue?vue&type=script&lang=js"
export * from "./RestaurantSettingsView.vue?vue&type=script&lang=js"

import "./RestaurantSettingsView.vue?vue&type=style&index=0&id=267ecc8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267ecc8d"]])

export default __exports__